import {schema as Schema} from 'normalizr';

export function createSchema(entityName: string, idAttribute = 'id') {
  const entity = new Schema.Entity(entityName, {}, {idAttribute});
  return new Schema.Array(entity);
}
